export default "__VITE_ASSET__CjV$xRYp__"